import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { GetString } from '../StringResourceManager';
import { Dialog } from '@progress/kendo-react-dialogs';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { ReportExportStatus } from '../../Interfaces/Reports/ReportExportStatus';
import { Grid, GridColumn } from '@progress/kendo-react-grid';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    confirmationDialog: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      flexWrap: 'wrap',
    },
    chip: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '4px 10px',
      borderRadius: 9999,
      backgroundColor: '#E8F0FE',
      border: '1px solid #C6DAFC',
      color: '#1A3D8F',
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '18px',
    },
    countButton: {
      fontSize: '0.9rem',
      width: '120px',
    },
    dataListContainer: {
      display: 'flex',
      gap: 8,
      flexWrap: 'wrap',
    },
  }),
);

interface Props {
  data: ReportExportStatus;
  field: string | undefined;
}

const CountDetailsDialog: React.FC<Props> = ({
  data,
  field,
}): React.ReactElement => {
  const classes = useStyles();
  const [showConfirmationDialog, setShowConfirmationDialog] =
    React.useState(false);
  const result = field == 'SiteNumbers' ? data.SiteNumbers : data.LaneNumbers;

  const handleButtonClick = () => {
    setShowConfirmationDialog(true);
  };

  const handleClose = () => {
    setShowConfirmationDialog(false);
  };

  const STORES = GetString('STORES');
  const LANES = GetString('LANES');
  const VIEW = GetString('VIEW');

  var gridData = result != undefined ? result.map(result => ({ result })) : [];

  return (
    <>
      <Button
        themeColor={'primary'}
        type="button"
        className={classes.countButton}
        onClick={handleButtonClick}
      >
        {`${VIEW} (${result?.length ?? 0})`}
      </Button>

      {showConfirmationDialog && (
        <Dialog
          title={field === 'SiteNumbers' ? STORES : LANES}
          onClose={handleClose}
        >
          <div className={classes.confirmationDialog}>
            <div className={classes.dataListContainer}>
              <Grid
                style={{ height: '650px', width: '700px' }}
                data={gridData}
                filterable={true}
                pageable={true}
                autoProcessData={true}
                take={50}
              >
                <GridColumn
                  field="result"
                  title={field === 'SiteNumbers' ? STORES : LANES}
                  filter="text"
                />
              </Grid>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default CountDetailsDialog;
